import { Component, ElementRef, Injector, Input, ViewContainerRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { PaymentDetailComponent } from '../payment-detail/payment-detail.component';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';
import { PreferenceService } from 'src/modules/base/shared/services/preference.service';
import moment from 'proxies/dayjs';

@Component({
    selector: 'app-view-payment-detail',
    templateUrl: './view-payment-detail.component.html',
    styleUrls: ['../payment-detail/payment-detail.component.scss'],
    standalone: false
})
export class ViewPaymentDetailComponent extends PaymentDetailComponent {
  approved_bill_value: any;
  buttonName: string;
  sponsorAmount: number = 0;
  charityRequest: any;
  charityRequestId: string;
  charityIncomeFields = [
    { key: 'income_type', label: 'field.label.type_of_income' },
    { key: 'income_source', label: 'field.label.income_source' },
    { key: 'ration_card_issue_year', label: 'field.label.ration_card_issue_year' },
    { key: 'income_certified_by', label: 'field.label.income_certified_by' },
    { key: 'tehsildar_income', label: 'field.label.tehsildar_income_inr' },
    { key: 'self_declared_income', label: 'field.label.self_declared_income_inr' },
    { key: 'ration_card_income', label: 'field.label.ration_card_income_inr' },
    { key: 'salary_slip_it_return_income', label: 'field.label.salary_slip_it_return_income_inr' }
  ];
  @Input() optical_billing_advance:boolean=false;
  @Input() optical_billing: boolean = false;

  constructor(
    public baseService: BaseService,
    public fb: FormBuilder,
    public activatedRoute: ActivatedRoute,
    public loader: LoaderService,
    public utilService: UtilService,
    public injector: Injector,
    public containerRef?: ViewContainerRef,
    public alertService?: AlertsService,
    public appService?: AppService,
    public elementRef?: ElementRef,
    public rolePermissionService?: RolePermissionService,
    public preferenceService?: PreferenceService
  ) {
    super(baseService, fb, activatedRoute, loader, utilService, injector, containerRef, alertService, appService, elementRef, rolePermissionService, preferenceService)
  }
  ngOnChanges(changes) {
    if (changes?.dataPay?.currentValue) {
      setTimeout(() => {
        this.updatePaymentViewControls();
      }, 1000);
    }
  }
  ngDoCheck() {
    // approved charity OP order keeps the sponsor sections hidden
    if (this.isCharityApproved()) return;
    this.checkSponsorWorkFlowEnabled();
    this.checkSponsorWorkFlowEnabledop();
  }
  checkSponsorWorkFlowEnabled() {
    if (this.navVar && this.isSponsorWorkFlowEnabledFlag) {
      for (let rcb of this.navVar) {
        if (rcb.field_name == "sponsor" && !rcb.show && this.appService.getApplication() == 'pharmacy') {
          rcb.show = true;
          break;
        }
      }
    }
  }
  checkSponsorWorkFlowEnabledop() {
    if (this.navVar && this.isSponsorWorkFlowEnabledFlag) {
      for (let rcb of this.navVar) {
        if (rcb.field_name == "Sponsor_billing" && !rcb.show && this.appService.getApplication() == 'payment') {
          rcb.show = true;
          break;
        }
      }
    }
  }
  ngOnInit() {
    super.ngOnInit();
    this.updatePaymentViewControls();
  }

  isadvance(event) {
    if (!this.optical_billing) {
      super.isadvance(event);
    } else {
      if (event.target['checked']) {
        this.getAdvanceAmount_(true,(result: any) => {
          let amt = Math.round(result);
          this.paymentForm.controls.is_default_amount.setValue(amt);
          // this.paymentForm.controls.net_receivable_amount.setValue(amt);
          if(this.paymentForm.controls.net_amount.value && this.paymentForm.controls.is_default_amount.value){
            let val = this.paymentForm.controls.net_amount.value - this.paymentForm.controls.is_default_amount.value;
            this.paymentForm.controls['net_receivable_amount'].setValue(val);
            this.paymentForm.controls['net_receivable_amount'].updateValueAndValidity();
            this.paymentForm.controls['received_amount'].setValue(val);
            this.paymentForm.controls['received_amount'].updateValueAndValidity();
            this.paymentForm.controls['net_receivable_amount'].setValue(this.paymentForm.controls.net_amount.value-amt);
            this.visibility.enableisadvance = true;
            this.is_advance_checked = true;
            this.showdata("added");
          }
        })
      } else {
        this.paymentForm.controls.is_default_amount.setValue(0);
        if(this.responses && this.responses.depositApiResponse && this.responses.depositApiResponse[0] && this.responses.depositApiResponse[0].available_amount){
          this.paymentForm.controls.is_default_amount.setValue(this.responses.depositApiResponse[0].available_amount);
        }
        // this.paymentForm.controls.is_default_amount_optical.setValue(0);
        this.paymentForm.controls.net_receivable_amount.setValue(Number(this.paymentForm.controls.net_amount.value).toFixed(this.appService._currentSessionData.currency_decimal_limit ? this.appService._currentSessionData.currency_decimal_limit : 2))
        this.showdata("removed");
        this.visibility.enableisadvance = true;
        this.is_advance_checked = false;
      }
    }
  }

  // checkAdvance() {
  //   if (!this.optical_billing) {
  //     super.isadvance(event);
  //   } else {
  //     // if (event.target['checked']) {
  //     //   let amt = Math.round(this.paymentForm.controls.net_receivable_amount.value);
  //     //   this.paymentForm.controls.is_default_amount.setValue(amt);
  //     //   // this.paymentForm.controls.net_receivable_amount.setValue(amt);
  //     //   this.visibility.enableisadvance = false;
  //     //   this.is_advance_checked = true;
  //     // }
  //     // else {
  //     //   this.paymentForm.controls.is_default_amount.setValue(0)
  //     //   this.paymentForm.controls.net_receivable_amount.setValue(Number(this.paymentForm.controls.net_amount.value).toFixed( this.appService._currentSessionData.currency_decimal_limit? this.appService._currentSessionData.currency_decimal_limit: 2))
  
  //     //   this.visibility.enableisadvance = true;
  //     //   this.is_advance_checked = false;
  //     // }
  //     this.paymentForm.controls.is_default_amount.setValue(this.paymentForm.controls.net_receivable_amount.value);
  //   }
  // }

  checkOpticalAmount(event) {
    let value: any = Number(this.paymentForm.controls.net_amount.value).toFixed(this.appService._currentSessionData.currency_decimal_limit ? this.appService._currentSessionData.currency_decimal_limit : 2);
    this.paymentForm.controls.net_receivable_amount.setValue(value - this.paymentForm.controls.is_default_amount_optical.value);
    this.resetPaymentDetail();
    if (this.paymentForm.controls['deposit_amount'].value != undefined) {
      if (this.paymentForm.controls['deposit_amount'].value > this.paymentForm.controls['net_receivable_amount'].value || this.paymentForm.controls['deposit_amount'].value == this.paymentForm.controls['net_receivable_amount'].value) {
        this.paymentForm.controls['net_receivable_amount'].setValue(0);
      }
      else {
        this.paymentForm.controls['received_amount'].setValue(value);
        if (value > 0) {
          this.paymentForm.controls['net_receivable_amount'].setValue(Number(value).toFixed(this.appService._currentSessionData.currency_decimal_limit ? this.appService._currentSessionData.currency_decimal_limit : 2));
        } else {
          this.paymentForm.controls['net_receivable_amount'].setValue(value);
        }
      }
    }
  }

  getAdvanceAmount_(advance=false,cb) {
    try {
      var data = {
        args:
          "uhId:" + this.patientInfo.uhId + ",admissionId:" + this.dataSet.orderId
      }
      // if (!this.paymentForm.controls['deposit_amount'].value && !this.paymentForm.controls['deposit_wallet_id'].value) {
        this.baseService.get("GET_TOTAL_DEPOSIT_BY_UHID", data.args, "deposit_wallet", "payment").subscribe(res => {
          if (res.errCode == 0) {
            this.responses.depositApiResponse = res.resource;
            let d = JSON.stringify(this.responses.depositApiResponse)
           
            let Obj ={
              isAdvance:advance,
              d:d
            }
            localStorage.setItem("iss____d",JSON.stringify(Obj));
            if (res.resource.length > 0) {
              cb(this.responses.depositApiResponse[0].available_amount);
            }
          }
        })
      // } else {
      //   //TODO
      // }
    } catch (e) {
      console.error('Error while fetching deposit', e);
    }
  }
  

  updatePaymentViewControls() {
    if (this.dataSet.transaction_type == "OP Edit Billing")
      this.buttonName = "Update Bill";
    else
      this.buttonName = "Create Bill"
    this.visibility.discountmultireason = true
    this.visibility.emplyee_recovery = true;
    this.visibility.duereasondisbale = true;
    if (this.dataSet?.op_amount_value?.payment?.due_authorised_by_id) {
      this.visibility.showField = true;
      this.amounts.is_due = true;
      this.visibility.showField = true;
      this.showDeposit = false;
    }
    if (this.dataSet && this.dataSet.result_approve_billing) {
      this.approved_bill_value = this.dataSet.result_approve_billing
    }
    if (this.approved_bill_value && this.approved_bill_value.discount_details && this.approved_bill_value.discount_details.discount && this.approved_bill_value.discount_details.discount != 0) {
      this.formService.blockMapping[1]['default_open'] = true;
    }
    if (this.approved_bill_value && this.approved_bill_value.due_details && this.approved_bill_value.due_details.due_amount && this.approved_bill_value.due_details.due_amount != 0) {
      this.formService.blockMapping[7]['default_open'] = true;
    }
    if (this.approved_bill_value && this.approved_bill_value.remarks && this.approved_bill_value.remarks != "") {
      this.formService.blockMapping[9]['default_open'] = true;
    }
    if (this.approved_bill_value && this.approved_bill_value.deposit_details && this.approved_bill_value.deposit_details.consumed_amount && this.approved_bill_value.deposit_details.consumed_amount != 0) {
      this.formService.blockMapping[2]['default_open'] = true;
    }
    if (this.approved_bill_value) {
      if (this.approved_bill_value.discount_details && this.approved_bill_value.discount_details && (this.approved_bill_value.discount_details.is_discount || this.approved_bill_value.discount_details.scheme_id) || (this.optical_billing && this.approved_bill_value && this.approved_bill_value.is_discount_applied)) {
        if (this.route.snapshot.params.resource == "approved_opticalorder")
          this.formService.blockMapping[1]['default_open'] = true;
        this.amounts.is_discount = true;
        if (this.approved_bill_value.discount_details.type == "scheme" && this.route.snapshot.params.resource == "approved_opticalorder") {
          this.visibility.schemeVisible = true;
          this.visibility.discountFieldVisible = false;
        }
        this.paymentForm.controls['type'].setValue(this.approved_bill_value.discount_details.type);
        if (this.route.snapshot.params.resource == "approved_opticalorder") {
          this.paymentForm.controls['scheme'].setValue(this.approved_bill_value.discount_details.scheme_name);
          this.paymentForm.controls['scheme_name'].setValue(this.approved_bill_value.discount_details.scheme_name);
        }
        if (this.approved_bill_value.payment && this.approved_bill_value.payment.sponsor_fund && this.approved_bill_value.payment.sponsor_fund.length > 0) {
          if (this.paymentForm.controls.sponsor_fund) {
            this.paymentForm.controls.sponsor_fund.setValue(this.approved_bill_value.payment.sponsor_fund);
          }
        }
        if (this.approved_bill_value && this.approved_bill_value.sponsor_fund && this.approved_bill_value.sponsor_fund.length > 0 && this.dataSet.transaction_type == "OP Billing") {
          if (this.paymentForm.controls.sponsor_fund) {
            this.sponsorAmount = 0;
            this.paymentForm.controls.sponsor_fund.setValue(this.approved_bill_value.sponsor_fund);
            this.approved_bill_value.sponsor_fund.forEach(element => {
              this.sponsorAmount += element.sanctioned_amount
            });
            this.paymentForm.controls.net_receivable_amount.setValue(Number(this.approved_bill_value.net_amount) - Number(this.sponsorAmount));
            this.paymentForm.controls.net_amount.setValue(Number(this.approved_bill_value.net_amount) - Number(this.sponsorAmount));
          }
        }
        this.paymentForm.controls['discount_on'].setValue(this.approved_bill_value.discount_details.discount_on);
        this.paymentForm.controls['discount_type'].setValue(this.approved_bill_value.discount_details.discount_type)
        this.paymentForm.controls['discount_value'].setValue(this.optical_billing ? this.approved_bill_value.discount_details.discount : this.approved_bill_value.discount_details.discount_value);
        this.paymentForm.controls['discount'].setValue(this.approved_bill_value.discount_details.discount);
        this.paymentForm.controls['is_discount'].setValue(true);
        this.paymentForm.controls['discount_reason'].setValue(this.approved_bill_value.discount_details.discount_reason);
        this.paymentForm?.controls?.['patient_criticality_code'].setValue(this.approved_bill_value?.patient_criticality_code);
        setTimeout(() => {
          this.paymentForm.controls['discount_authorized_by'].setValue(this.approved_bill_value.discount_details.discount_authorized_by_id);
          this.paymentForm.controls['discount_authorized_by_name'].setValue(this.approved_bill_value.discount_details.discount_authorized_by_name);
          this.paymentForm.updateValueAndValidity();
        });
        this.paymentForm.controls['remarks'].setValue(this.approved_bill_value.remarks);
        if (this.approved_bill_value.discount_details.scheme && this.approved_bill_value.discount_details.type == "scheme") {
          this.visibility.schemeVisible = true;
          this.paymentForm.controls['scheme'].setValue(this.approved_bill_value.discount_details.scheme_name)
          this.visibility.discountFieldVisible = false;
        }
      }
      if (this.approved_bill_value.due_details && this.approved_bill_value.due_details && this.approved_bill_value.due_details.due_amount_authorized_by_id) {
        this.amounts.is_due = true;
        this.visibility.showField = true;
        this.paymentForm.controls['due_amount'].setValue(this.approved_bill_value.due_details.due_amount);
        this.paymentForm.controls['is_due'].setValue(true);
        this.showDeposit = false;
        this.paymentForm.controls['due_reason'].setValue(this.approved_bill_value.due_details.due_reason);
        if (this.approved_bill_value.due_details && this.approved_bill_value.due_details.employee_recovery_details) {
          this.paymentForm.controls['recovery'].setValue(this.approved_bill_value.due_details.employee_recovery_details.name);
          this.paymentForm.controls['noOfInstallment'].setValue(this.approved_bill_value.due_details.employee_recovery_details.no_of_installment);
        }
        setTimeout(() => {
          this.paymentForm.controls['due_authorised_by_id'].setValue(this.approved_bill_value.due_details.due_amount_authorized_by_id);
          this.paymentForm.controls['due_authorised_by_id'].updateValueAndValidity();
          this.paymentForm.updateValueAndValidity();
        }, 1000);
        this.paymentForm.controls['remarks'].setValue(this.approved_bill_value.remarks)
        this.getDueData();
      }
      if (this.approved_bill_value.delivery_charges_component && this.approved_bill_value.delivery_charges_component && this.approved_bill_value.delivery_charges_component.service_name) {
        this.amounts.item_charges = true;
        this.paymentForm.controls['item_charges'].setValue(true);
        this.paymentForm.controls['item_name'].setValue(this.approved_bill_value.delivery_charges_component.service_name);

      }
      if (this.approved_bill_value.delivery_charges && this.approved_bill_value.delivery_charges && this.approved_bill_value.delivery_charges.service_name) {
        this.amounts.item_charges = true;
        this.paymentForm.controls['item_charges'].setValue(true);
        this.paymentForm.controls['item_name'].setValue(this.approved_bill_value.delivery_charges.service_name);

      }
    }
    if(this.optical_billing)
    {
      if(this.approved_bill_value && this.approved_bill_value.previous_paid_details)
      {
        this.paymentForm.controls.is_default_amount.setValue(this.approved_bill_value.previous_paid_details.deposit_amount);
        this.paymentForm.controls.used_advance_amount.setValue(this.approved_bill_value.previous_paid_details.consumed_amount);
      }
    }
    this.hideCharityApprovedSections();
    this.loadCharityRequest();
    console.log("this.dataset ", this.approved_bill_value);
  }

  // approved charity OP order: show the charity fields it was raised with (charity given by and income
  // details are on the charity_request_details billing raised for the order)
  // OP approve billing only: this view is shared with IP, pharmacy and optical approvals, which keep their flow
  isCharityApproved() {
    let isOpBilling = this.dataSet?.transaction_type == 'OP Billing' || this.dataSet?.transaction_type == 'OP Edit Billing';
    return isOpBilling && (this.approved_bill_value?.is_charity === true || this.approved_bill_value?.is_charity === 'true');
  }

  loadCharityRequest() {
    let id = this.approved_bill_value?.charity_request_details_id;
    if (!this.isCharityApproved() || !id || this.charityRequestId == id) return;
    this.charityRequestId = id;
    this.baseService.getById(id, 'charity_request_details', 'billing').subscribe(res => {
      let request = res?.resource?.[0] ?? res;
      if (!request || res?.errCode == -1 || request.errCode == -1) return;
      this.charityRequest = request;
      // income details block is hidden by default (only charity OP billing turns it on)
      this.navVar?.forEach(section => { if (section?.block_id == 'income_details') section.show = true; });
    }, () => {});
  }

  // approved charity OP order: same sections as charity OP billing (hideCharitySections), but payment details
  // stay so the approved order can be billed
  hideCharityApprovedSections() {
    if (!this.isCharityApproved()) return;
    this.navVar?.forEach(section => { if (section?.block_id == 'upload_document') section.show = true; });
    let hidden = ['deposit', 'sponsor', 'Sponsor_billing', 'advance', 'due', 'delivery_charges', 'remarks'];
    this.navVar?.forEach(section => {
      if (hidden.includes(section?.block_id)) {
        section.show = false;
        section.default_open = false;
      }
    });
    this.showDeposit = false;
  }

  // the parent calls this after the async sponsor config (showSponsorBlock) turns the sponsor section back on
  hideCharitySections() {
    super.hideCharitySections();
    this.hideCharityApprovedSections();
  }

  // documents uploaded on the charity OP order (documentIds, same key as charity_request_details.json)
  charityDocuments() {
    let documents = this.charityRequest?.documentIds ?? this.approved_bill_value?.documentIds;
    return Array.isArray(documents) && documents.length > 0 ? documents : null;
  }

  // blank for a missing or unparseable date
  charityDate(value) {
    if (value === null || value === undefined || value === '') return '';
    let date = moment(isNaN(Number(value)) ? value : Number(value));
    return date.isValid() ? date.format('DD/MM/YYYY') : '';
  }

  // blank for null / undefined / empty income values (0 is kept)
  charityIncome(key) {
    let value = this.charityRequest?.income_details?.[key];
    return value === null || value === undefined ? '' : String(value);
  }
  ngAfterViewInit() {
    // Object.keys(this.paymentForm.controls).forEach(key => {
    //   this.paymentForm.controls[key].disable();
    // });
  }

  resetAllData(value) {
    // this.showPaymentdeails = true;
    if (this.paymentForm.controls['payment_detail'] && this.paymentForm.controls['payment_detail'].value && this.paymentForm.controls['payment_detail'].value.length > 0) {
      this.compositeArrayComponent.removeAllItems();
      this.paymentForm.controls['payment_detail'].setValue([]);
    }
    this.resetDueCheckbox();
    this.paymentForm.controls['is_used_deposit'].setValue(false);
    this.visibility.enableUseDepositAmt = true;
    this.amounts.is_used_deposit = false;
    this.paymentForm.controls['used_deposit_amount'].setValue(0);
    if (value.scheme_id != undefined && value.scheme_id) {
      this.visibility.schemeVisible = true;
      this.visibility.disableField = false;
      this.amounts.is_discount = true;
      this.visibility.discountFieldVisible = false;
      this.paymentForm.controls['is_discount'].setValue(true);
      if (this.dataSet.result_approve_billing && this.dataSet.result_approve_billing.discount_details && this.dataSet.result_approve_billing.discount_details.type == 'direct') {
      } else {
        this.bindDropDownsFormExternalResources('scheme');
        this.paymentForm.controls['type'].setValue('scheme');
      }
      if (this.dataSet && this.dataSet.transaction_type && this.dataSet.transaction_type == "OP Billing") {
        if (this.appService.getUniversalConfig('multi_care_type')) {
          this.schemeApiSignature['args'] = "care_type:" + this.appService.getDynamicFunctions("getCurrentCareType")
        }
      }
      if (this.responses.schemeResponse == undefined) {
        if (this.dataSet.result_approve_billing && this.dataSet.result_approve_billing.discount_details && this.dataSet.result_approve_billing.discount_details.type == 'direct')
          return
        this.baseService.getByDataSource(this.schemeApiSignature).subscribe(res => {
          if (res.errCode == 0 && res.count > 0 && this.responses.schemeResponse == undefined) {
            this.responses.schemeResponse = res.resource;
            this.visibility.schemeVisible = true;
            this.visibility.disableField = false;
            this.amounts.is_discount = true;
            this.visibility.discountFieldVisible = false;
            this.paymentForm.controls['is_discount'].setValue(true);
            if (value && value.scheme_id && !value.scheme_name) {
              this.paymentForm.controls['scheme'].setValue(this.approved_bill_value.discount_details.scheme_name);
            }
            else {
              this.paymentForm.controls['scheme'].setValue(value.scheme);
              this.paymentForm.controls['scheme_name'].setValue(value.scheme_name);
            }
          }
        });
      }

    } else if (value.discount == 0) {
      if (this.amounts) {
        this.amounts.is_discount = false;
      }
      this.visibility.disableField = true;
      this.paymentForm.controls['is_discount'].setValue(false);
      this.visibility.discountFieldVisible = true;
      this.visibility.schemeVisible = false;
      this.paymentForm.controls['discount_on'].reset('');
      this.paymentForm.controls['discount_type'].reset('amount');
      this.paymentForm.controls['discount_reason'].reset('');
      this.paymentForm.controls['discount_authorized_by'].reset('');
      this.paymentForm.controls['discount_authorized_by_id'].reset('');
      this.paymentForm.controls['discount'].reset(0);
      this.paymentForm.controls['scheme'].reset('');
      this.paymentForm.controls['type'].setValue('direct');
      this.serviceDiscount.emit({ 'checked': this.amounts.is_discount, type: this.paymentForm.controls['type'].value, discount_on: this.paymentForm.controls['discount_on'].value, discount_type: this.paymentForm.controls['discount_type'].value, typeToggled: true });
    }
    if (this.paymentForm.controls['discount_type'].value == "percentage" && this.paymentForm.controls['discount_on'].value == "bill")
      this.paymentForm.controls['discount_value'].setValue(value.op_amount_value.discount_value);
    else {
      this.paymentForm.controls['discount_value'].setValue(value.op_amount_value.discount);
      if (value && value.op_amount_value && value.op_amount_value.payment) {
        if (value.op_amount_value.payment.discount_type == "percentage") {
          this.paymentForm.controls['discount_value'].setValue(value.op_amount_value.payment.discount_value);
          this.paymentForm.controls['discount_type'].setValue(value.op_amount_value.payment.discount_type);
        }
        this.paymentForm.controls['discount_on'].setValue(value.op_amount_value.payment.discount_on);
        this.paymentForm.controls['type'].setValue(value.op_amount_value.payment.type);
        this.paymentForm.controls['remarks'].setValue(value.op_amount_value.payment.remarks);
        this.paymentForm.controls['discount_reason'].setValue(value.op_amount_value.payment.discount_reason);
        this.paymentForm.controls['discount_authorized_by'].setValue(value.op_amount_value.payment.discount_authorized_by);
        this.paymentForm.controls['discount_authorized_by_name'].setValue(value.op_amount_value.payment.discount_authorized_by_name);
        this.paymentForm?.controls?.['patient_criticality_code']?.setValue(this.approved_bill_value?.patient_criticality_code);
        if (this.dataSet?.op_amount_value?.payment?.due_authorised_by_id) {
          this.amounts.is_due = true;
          if (this.dataSet?.op_amount_value?.button == "createBillApprove" || this.dataSet?.op_amount_value?.button == "printBillApprove") {
            this.paymentForm.controls['due_amount'].setValue(Number(this.dataSet.op_amount_value.payment.final_amount + this.dataSet.op_amount_value.roundOff));
          }
          else {
            this.paymentForm.controls['due_amount'].setValue(this.dataSet.op_amount_value.payment.due_amount);
          }
          this.paymentForm.controls['is_due'].setValue(true);
          this.paymentForm.controls['due_reason'].setValue(this.dataSet.op_amount_value.payment.due_reason);
          this.paymentForm.controls['due_authorised_by_name'].setValue(this.dataSet.op_amount_value.payment.due_authorised_by_name);
          setTimeout(() => {
            this.paymentForm.controls['due_authorised_by_id'].setValue(this.dataSet.op_amount_value.payment.due_authorised_by_id);
            this.paymentForm.controls['due_authorised_by_id'].updateValueAndValidity();
            this.paymentForm.updateValueAndValidity();
          }, 1000);
          this.getDueData()
        }
      }
    }
  }

  customPatternapplid() {
    if (this.configValueDecimal == "No") {
      return "^[0-9+]*$"
    } else {
      return "^\\d{1,9}(\\.\\d{1,2})?$"
    }
  }
  ngOnDestroy() {
    localStorage.removeItem("iss____d");
  }
}
